import {ReactNode} from 'react';
import {Box} from '@mui/material';

export default function StepContainer({children}: {children: ReactNode}) {
  return (
    <Box
      sx={(theme) => ({
        pb: `calc(${theme.spacing(12)} + min(env(safe-area-inset-bottom, ${theme.spacing(
          2
        )}), ${theme.spacing(2)}))`,
        '& .MuiMobileStepper-root': {
          boxShadow: 15
        }
      })}
    >
      {children}
    </Box>
  );
}
